export default "__VITE_ASSET__kA8b_toQ__"